import { render, staticRenderFns } from "./NavItemDropdown.vue?vue&type=template&id=2f64533b&"
import script from "./NavItemDropdown.vue?vue&type=script&lang=js&"
export * from "./NavItemDropdown.vue?vue&type=script&lang=js&"
import style0 from "./NavItemDropdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports